import React, { useState } from "react";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  IconButton,
  Popper,
  Paper,
  MenuItem,
  ClickAwayListener,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import {
  setAppetiteData,
  selectedApplicationData,
} from "../store/ApplicationSlice";
import axios from "axios";
import Breadcrumb from "./Breadcrumb";
import SupportForm from "./supportForm/supportForm";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location
  const [anchorEl, setAnchorEl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchApplicationData = async () => {
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");

    const headers = {
      "X-Access-Token": accessToken,
      "X-Refresh-Token": refreshToken,
      Accept: "application/json",
    };
    try {
      const response = await axios.get(
        "https://insureai-intake-dev-1074099157700.us-central1.run.app/insureai/ml/intake/applications/v2/?skip=0&limit=0",
        { headers }
      );

      dispatch(setAppetiteData(response.data));
      dispatch(selectedApplicationData(response.data[0]));
    } catch (error) {
      console.error("Error fetching application data:", error);
    }
  };

  const handlePopperOpen = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handlePopperClose = () => {
    setAnchorEl(null);
  };

  const handleAppetiteManagement = () => {
    navigate("/app/appetite");
    handlePopperClose();
  };
  const handleSupport = () => {
    setIsModalOpen(true);
    handlePopperClose();
  };

  return (
    <header className="bg-white py-2">
      <div className="flex justify-between items-center mx-auto container">
        {/* Logo Section */}
        <div className="flex items-center" onDoubleClick={fetchApplicationData}>
          <img
            src="/img/logo.svg"
            alt="Nativeorange, LLC"
            className="h-16"
            onClick={() => navigate("/app/details")}
            style={{ width: "8rem", cursor: "pointer" }}
          />
        </div>

        {/* Title Section */}
        <div className="text-orange-600 font-bold text-2xl product-title">
          LexiWrite
        </div>

        {/* Icons Section */}
        <div className="flex items-center space-x-4 top-nav-icons">
          <IconButton>
            <NotificationsIcon style={{ color: "#FF8C00" }} />
          </IconButton>

          <IconButton onClick={handlePopperOpen}>
            <SettingsIcon style={{ color: "#FF8C00" }} />
          </IconButton>

          <Popper
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            placement="bottom-end"
            style={{ zIndex: 1300 }}
            className="appetite-popover"
          >
            <ClickAwayListener onClickAway={handlePopperClose}>
              <Paper>
                <MenuItem onClick={handleAppetiteManagement}>
                  Appetite Management
                </MenuItem>
                <MenuItem onClick={handleSupport}>Help & Support</MenuItem>
              </Paper>
            </ClickAwayListener>
          </Popper>

          <IconButton>
            <AccountCircleIcon style={{ color: "#FF8C00" }} />
          </IconButton>
        </div>
      </div>

      {/* Render Breadcrumb only if the location is not root */}
      {location.pathname !== "/" && (
        <div className="justify-between items-center mx-auto container">
          <Breadcrumb />
        </div>
      )}
      {/* Support Form as a Modal */}
      <SupportForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
}

export default Header;
